var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { staticClass: "title typographies-heading-h2" }, [
      _vm._v(
        "\n        " +
          _vm._s(_vm.$l10n.__("Paramètres des champs personnalisés")) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "subtitle typographies-paragraph-medium-regular" }, [
      _vm._v(
        "\n        " +
          _vm._s(
            _vm.$l10n.__(
              "Cette section vous permet de déterminer les actions que nous devons effectuer uniquement sur les champs personnalisés."
            )
          ) +
          "\n    "
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "cf-container" },
      _vm._l(_vm.customFields, function(customField, customFieldKey) {
        return _c(
          "div",
          { key: customFieldKey, staticClass: "cf-item" },
          [
            _c(
              "div",
              { staticClass: "cf-title" },
              [
                _c(
                  "span",
                  { staticClass: "typographies-paragraph-medium-semibold" },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(customField.title) +
                        "\n                "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "CompassTooltip",
                  {
                    attrs: {
                      contentClass: "tooltip-import-options",
                      placement: "bottom-start"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "content",
                          fn: function() {
                            return _vm._l(customField.values, function(choice) {
                              return _c("div", { key: choice.value }, [
                                _c(
                                  "h4",
                                  { staticClass: "typographies-heading-h4" },
                                  [_vm._v(_vm._s(choice.label))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "typographies-paragraph-small-semibold"
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(choice.description) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              ])
                            })
                          },
                          proxy: true
                        }
                      ],
                      null,
                      true
                    )
                  },
                  [
                    _vm._v(" "),
                    _c("CompassIcon", {
                      attrs: { icon: "info-circle-fill", size: "small" }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "CompassSelect",
              {
                attrs: { menuClass: "menu-import-dialog" },
                model: {
                  value: _vm.getOptionsSelectedImport[customFieldKey],
                  callback: function($$v) {
                    _vm.$set(_vm.getOptionsSelectedImport, customFieldKey, $$v)
                  },
                  expression: "getOptionsSelectedImport[customFieldKey]"
                }
              },
              _vm._l(customField.values, function(option) {
                return _c(
                  "CompassDropdownSelectOption",
                  _vm._b(
                    { key: option.value },
                    "CompassDropdownSelectOption",
                    option,
                    false
                  )
                )
              }),
              1
            )
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "span",
      {
        staticClass:
          "typographies-paragraph-small-regular caption-last-cf-select"
      },
      [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Champs personnalisés de type bouton radio, choix multiple, liste de choix"
              )
            ) +
            "\n    "
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }